import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Goals } from './components/Goals';
import { Donation } from './components/Donation';
import { Highlights } from './components/Highlights';
import { Quote } from './components/Quote';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white w-full overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Story data-id="element-4" />
        <Goals data-id="element-5" />
        <Donation data-id="element-6" />
        <Highlights data-id="element-7" />
        <Quote data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}